import { httpClient, unwrap } from './httpClient';

export async function listDeposits({ search, userIds, status, sortBy, sortDir, page, pageSize }) {
  const response = await httpClient.get('/admin/deposits/', {
    params: {
      search: search || undefined,
      user_ids: userIds?.length ? userIds.join(',') : undefined,
      status: status ?? undefined,
      sort_by: sortBy,
      sort_dir: sortDir,
      page,
      page_size: pageSize,
    },
  });
  return unwrap(response);
}

export async function approveDeposit(id) {
  const response = await httpClient.post(`/admin/deposits/${id}/approve`);
  return unwrap(response);
}

const adminDepositService = {
  listDeposits,
  approveDeposit,
};

export default adminDepositService;
